import { Trans } from '@lingui/react'
import classNames from 'clsx'
import type { VFC } from 'react'

import { IS_NODE } from 'shared/consts/env'
import noop from 'shared/utils/noop'
import IconArrowLeft from 'views/components/atoms/Icon/IconArrowLeft'
import IconCross from 'views/components/atoms/Icon/IconCross'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import type {
  NavigationHeaderProps,
  UserData,
} from 'views/components/organisms/CmsMobileMenu/types'

const NavigationHeader: VFC<NavigationHeaderProps> = ({
  backButton,
  closeMenuHandler,
  goBackHandler,
  userData,
}) => {
  const classes = classNames('o-OffCanvasView__header l-flex u-no-margin', {
    'u-padding--left': !backButton,
  })

  const headerText = (
    user: UserData | undefined,
    backButtonExists: boolean
  ) => {
    if (backButtonExists) {
      return <Trans id="general.link.label.back" />
    }

    if (user?.isLoggedIn) {
      return (
        <>
          <Trans id="offcanvas.header.hello" />
          {` ${user.user.firstName}`}
        </>
      )
    }

    return <Trans id="offcanvas.header.title" />
  }

  return (
    <h3 className={classes} suppressHydrationWarning id="OffCanvasViewHeader">
      {backButton && (
        <ButtonTransparent
          alternative
          inline
          name="go-back-navigation"
          onClick={goBackHandler}
        >
          <IconArrowLeft />
          <span className="a-visuallyhidden">Go Back</span>
        </ButtonTransparent>
      )}

      <span
        className="l-flex__primary"
        data-clientside-hook="OffCanvasMenu__header-greeting"
        data-cs-mask="true"
      >
        {headerText(userData, !!backButton)}
      </span>

      <ButtonTransparent
        alternative
        aria-controls="OffCanvasMenu"
        data-clientside-hook="menu-button"
        inline
        name="close-navigation"
        {...(IS_NODE ? { href: '#' } : { onClick: closeMenuHandler })}
      >
        <IconCross />
        <span className="a-visuallyhidden">Close navigation</span>
      </ButtonTransparent>
    </h3>
  )
}

NavigationHeader.defaultProps = {
  backButton: false,
  closeMenuHandler: noop,
  goBackHandler: noop,
  userData: undefined,
}

export default NavigationHeader
